module.exports = __webpack_public_path__ + "static/media/8.14dbf5ed.jpg";